import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  Areas,
  Routes,
  RoutesAreas,
  VanTransfer,
  VanTransferLocal,
  VanTrasnferRoute,
} from '../models/vanTransfer.model';
import { UserLogan, UserLoganAirports } from '../models/userLogan';

@Injectable({
  providedIn: 'root',
})
export class VanTransferService {
  private apiServerUrl = environment.loganConfig.url;
  private isApiServerProd = environment.production;

  constructor(private http: HttpClient) {}

  public getVanTransfer(userLogan: UserLoganAirports): Observable<VanTransfer> {
    return this.http.post<VanTransfer>(
      `${this.apiServerUrl}/api/vanTransfer/getVanTransfer`,
      userLogan,
      { withCredentials: true }
    );
  }
  public insertVanTransfer(vanTransfer: VanTransfer): Observable<VanTransfer> {
    return this.http.post<VanTransfer>(
      `${this.apiServerUrl}/api/vanTransfer/insertVanTransfer`,
      vanTransfer,
      { withCredentials: true }
    );
  }
  public updateVanTransfer(
    vanTransfer: VanTransfer,
    plate: string
  ): Observable<any> {
    return this.http.post<any>(
      `${this.apiServerUrl}/api/vanTransfer/updateVanTransfer/${plate}`,
      vanTransfer,
      { withCredentials: true }
    );
  }
  public inactiveVanTransfer(plate: string, idUser: number): Observable<any> {
    return this.http.get<any>(
      `${this.apiServerUrl}/api/vanTransfer/inactiveVanTransfer/${plate}/${idUser}`
    );
  }

  public deleteVanTransfer(plate: string): Observable<any> {
    return this.http.get<any>(
      `${this.apiServerUrl}/api/vanTransfer/deleteVanTransfer/${plate}`
    );
  }

  public selectVanTransferLocal(
    userLogan: UserLoganAirports
  ): Observable<VanTransferLocal> {
    return this.http.post<VanTransferLocal>(
      `${this.apiServerUrl}/api/vanTransfer/selectVanTransferLocal`,
      userLogan,
      { withCredentials: true }
    );
  }

  public changeVanTransferRoute(
    vanTransferRoute: VanTrasnferRoute
  ): Observable<VanTrasnferRoute> {
    return this.http.post<VanTrasnferRoute>(
      `${this.apiServerUrl}/api/vanTransfer/changeVanTransferRoute`,
      vanTransferRoute,
      { withCredentials: true }
    );
  }

  public selectRoutes(userLogan: UserLoganAirports): Observable<Routes> {
    return this.http.post<Routes>(
      `${this.apiServerUrl}/api/vanTransfer/selectRoutes`,
      userLogan,
      { withCredentials: true }
    );
  }

  public insertRoutes(route: Routes): Observable<any> {
    return this.http.post<Routes>(
      `${this.apiServerUrl}/api/vanTransfer/insertRoutes`,
      route,
      { withCredentials: true }
    );
  }
  public updateRoutes(route: Routes): Observable<any> {
    return this.http.post<Routes>(
      `${this.apiServerUrl}/api/vanTransfer/updateRoutes`,
      route,
      { withCredentials: true }
    );
  }
  public deleteRoute(route: Routes): Observable<any> {
    return this.http.post<Routes>(
      `${this.apiServerUrl}/api/vanTransfer/deleteRoute`,
      route,
      { withCredentials: true }
    );
  }

  public selectAreas(): Observable<Areas> {
    return this.http.get<Areas>(
      `${this.apiServerUrl}/api/vanTransfer/selectAreas`
    );
  }
  public insertArea(area: Areas): Observable<any> {
    return this.http.post<Areas>(
      `${this.apiServerUrl}/api/vanTransfer/insertArea`,
      area,
      { withCredentials: true }
    );
  }
  public updateArea(area: Areas): Observable<any> {
    return this.http.post<any>(
      `${this.apiServerUrl}/api/vanTransfer/updateArea`,
      area,
      { withCredentials: true }
    );
  }

  public deleteArea(area: Areas): Observable<any> {
    return this.http.post<Routes>(
      `${this.apiServerUrl}/api/vanTransfer/deleteArea`,
      area,
      { withCredentials: true }
    );
  }
  public insertRouteArea(routeAreas: RoutesAreas): Observable<any> {
    return this.http.post<RoutesAreas>(
      `${this.apiServerUrl}/api/vanTransfer/insertRouteArea`,
      routeAreas,
      { withCredentials: true }
    );
  }

  public searchPlate(plate: String){
    return this.http.get<any>(
      `${this.apiServerUrl}/api/vanTransfer/searchPlate/${plate}`,
      { withCredentials: true }
    );
  }

  public selectRoutesAreas(): Observable<RoutesAreas> {
    return this.http.get<RoutesAreas>(
      `${this.apiServerUrl}/api/vanTransfer/selectRoutesAreas`
    );
  }

  public async reloadCache() {
    const response = await fetch(
      `https://transfer-movida.satrastreamento.${
        this.isApiServerProd ? 'com' : 'dev'
      }.br/reloadcaches`,
      {
        method: 'GET',
        headers: {
          Accept: 'application/json',
        },
      }
    );
    if (!response.ok) {
      throw new Error(`Error! status: ${response.status}`);
    }
  }
}
